module.exports = __webpack_public_path__ + "static/media/ESGLogo.357ba2c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ESGLogo.png
// module id = 56
// module chunks = 4